<template>
  <div style="padding: 20px">
    <el-button type="primary" @click="doOpenDialog">添加订正</el-button>
    <el-dialog
      v-drag:common
      :visible="visible"
      title="添加订正"
      width="500px"
      @open="getTowerList"
      @close="visible = false"
    >
      <el-form
        label-width="130px"
        class="demo-ruleForm"
        :rules="rules"
        :model="formData"
        ref="ruleForm"
      >
        <el-form-item label="订正半径(km)" prop="radius">
          <el-input v-model.number="formData.radius"></el-input>
        </el-form-item>
        <el-form-item label="选择测风塔" prop="towerIds">
          <div class="tree-wrapper">
            <el-tree ref="towerTree" :data="treeTowerData" show-checkbox>
            </el-tree>
          </div>
        </el-form-item>
      </el-form>
      <div class="btn">
        <el-button type="primary" @click="save" :disabled="disableSaveButton"
          >订正</el-button
        >
        <el-button @click="visible = false">取消</el-button>
      </div>
    </el-dialog>
    <el-table ref="table" :data="correctionList">
      <el-table-column label="测风塔" prop="towerCode" width="200">
      </el-table-column>
      <el-table-column label="开始订正时间" width="200" prop="createTime">
      </el-table-column>
      <el-table-column label="状态" width="120" prop="stateText">
      </el-table-column>
      <el-table-column label="订正完成时间" width="200" prop="finishTime">
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      formData: {
        radius: '',
        towerIds: ''
      },
      correctionList: [],
      treeTowerData: [],
      visible: false,
      disableSaveButton: false,
      rules: {
        radius: [
          { required: true, message: '请输入半径', trigger: 'blur' },
          {
            min: 30,
            max: 300,
            message: '半径大于等于30km且小于等于300km',
            trigger: 'blur',
            type: 'number'
          }
        ]
      }
    };
  },
  mounted() {
    this.getCorrectionTower();
  },
  methods: {
    doOpenDialog() {
      this.formData.radius = '';
      this.treeTowerData = [];
      this.visible = true;
    },
    async getCorrectionTower() {
      const res = await this.$fetch('/manage/tower/getcorrectionTower', {
        module: 'manage'
      });
      this.correctionList = res.data.data;
      this.correctionList.map(item => {
        if (item.state === 0) {
          item.stateText = '未订正过';
        } else if (item.state === 1) {
          item.stateText = '订正中';
        } else if (item.state === 2) {
          item.stateText = '订正完成';
        }
        return item;
      });
    },
    async getTowerList() {
      const res = await this.$fetch('/manage/tower/getTowerList', {
        module: 'manage'
      });
      const towerList = res.data.data;
      let unCorrect = {
        id: 'unCorrect',
        label: '未订正过',
        children: []
      };
      let correcting = {
        id: 'correcting',
        label: '订正中',
        children: []
        // disabled: diasbled
      };
      let corrected = {
        id: 'corrected',
        label: '订正完成',
        children: []
      };
      towerList.map(i => {
        let node = {
          id: i.towerId,
          label: i.towerCode
        };
        if (i.correctFlag == 0) unCorrect.children.push(node);
        if (i.correctFlag == 1) correcting.children.push(node);
        if (i.correctFlag == 2) corrected.children.push(node);
      });
      this.treeTowerData.push(unCorrect, correcting, corrected);
      if (correcting.children.length > 0) {
        this.disableSaveButton = true;
      }
      //console.log(this.treeTowerData);
    },
    async save() {
      let checkTowers = this.$refs.towerTree.getCheckedNodes();
      let towerIdArr = [];
      for (let i = 0; i < checkTowers.length; i++) {
        towerIdArr.push(checkTowers[i].id);
      }
      if (towerIdArr.length == 0) {
        return this.$message.warning('请选择测风塔！');
      }
      let towerIds = towerIdArr.toString();
      //console.log({ checkTowers });
      //console.log({ towerIds });
      this.$refs.ruleForm.validate(async valid => {
        if (valid) {
          await this.$postForm({
            url: '/manage/tower/correctionTower',
            module: 'manage',
            data: {
              radius: this.formData.radius,
              towerIds: towerIds
            },
            showLoading: true,
            showError: true,
            showSuccess: true
          });
          await this.getCorrectionTower();
        } else {
          return false;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
/deep/.el-table__empty-block {
  background-color: #fff;
}
/deep/.el-form {
  padding: 10px;
  .el-form-item__label {
    color: #ffffff;
  }
}
/deep/.btn {
  display: flex;
  justify-content: center;
  align-items: center;

  .el-button {
    display: inline-block;
  }
}

.tree-wrapper {
  max-height: 350px;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
}
</style>
